import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "SignUp", -1)
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "d-grid gap-2" }
const _hoisted_4 = { class: "text-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "form-control",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
        placeholder: "Email"
      }, null, 512), [
        [_vModelText, _ctx.mail]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "form-control",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass) = $event)),
        placeholder: "Password"
      }, null, 512), [
        [_vModelText, _ctx.pass]
      ]),
      _withDirectives(_createElementVNode("input", {
        type: "password",
        class: "form-control",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pass2) = $event)),
        placeholder: "Repeat password"
      }, null, 512), [
        [_vModelText, _ctx.pass2]
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.SignUp && _ctx.SignUp(...args))),
          class: "btn btn-primary"
        }, "Sign Up")
      ]),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.error), 1)
    ])
  ], 64))
}